'use client';

import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { List } from '@jouzen/ecom-components/v3/List';
import { ListItem } from '@jouzen/ecom-components/v3/ListItem';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { TypographyRhythm } from '@jouzen/ecom-components/v3/TypographyRhythm';

const Content = () => {
  return (
    <LayoutGrid>
      <div className="col-main">
        <TypographyRhythm>
          <Typography variant="h1" Element="h1">
            Saavutettavuusseloste
          </Typography>

          <Typography>
            Tämä on ŌURA verkkokaupan saavutettavuusseloste. Seloste koskee
            palvelua:
            <BodyLink href="/">www.ouraring.com</BodyLink>
          </Typography>

          <Typography>
            ŌURA pyrkii takaamaan verkkokauppansa saavutettavuuden digitaalisten
            palveluiden tarjoamisesta annetun lain (306/2019) ja EU:n
            saavutettavuusdirektiivin mukaisesti. Tavoitteenamme on tarjota
            verkkopalvelu, joka on saavutettava kaikille käyttäjille, mukaan
            lukien henkilöt, joilla on erilaisia toimintarajoitteita.
          </Typography>

          <Typography variant="h4" Element="h2" className="font-normal">
            Verkkokaupan saavutettavuuden tila
          </Typography>

          <Typography>
            Tällä hetkellä verkkokauppaa ei ole vielä arvioitu saavutettavuuden
            osalta. Arviointi on kuitenkin käynnissä, ja
            saavutettavuusselostetta päivitetään arvioinnin valmistuttua.
          </Typography>

          <Typography>
            Palvelussa saattaa esiintyä saavutettavuuspuutteita. Tiedotamme
            yksityiskohtaisesti havaitut puutteet ja korjaustoimenpiteet
            saavutettavuusarvioinnin jälkeen.
          </Typography>

          <Typography>
            Päivitämme saavutettavuusselosteen viimeistään 31.08.2025
          </Typography>

          <Typography variant="h4" Element="h2" className="font-normal">
            Huomasitko saavutettavuuspuutteen digipalvelussamme? Anna
            palautetta.
          </Typography>

          <Typography>
            Jos huomaat sivustolla saavutettavuusongelman, voit antaa siitä
            palautetta. Ensisijaisesti pyydämme ottamaan yhteyttä palvelun
            ylläpitäjään:
          </Typography>

          <Typography>
            <BodyLink href="https://support.ouraring.com" color="inherit">
              Palautekanavan
            </BodyLink>
          </Typography>

          <Typography>
            Kerro palautteessasi mahdollisimman tarkasti, mikä osa sivustosta on
            kyseessä ja millainen ongelma on havaittu. Vastaamme palautteeseen
            14 päivän kuluessa. Voit myös pyytää ei-saavutettavaa sisältöä
            saavutettavassa muodossa.
          </Typography>

          <Typography>
            Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta
            lain edellyttämässä ajassa (14 päivässä), voit tehdä ilmoituksen
            valvontaviranomaiselle:
          </Typography>

          <Typography weight="bold">
            Liikenne- ja viestintävirasto Traficom
          </Typography>

          <Typography className="mb-0">
            Digitaalisen esteettömyyden ja saavutettavuuden valvontayksikkö
          </Typography>
          <List className="mt-0">
            <ListItem>
              <BodyLink
                href="https://www.saavutettavuusvaatimukset.fi"
                color="inherit"
              >
                www.saavutettavuusvaatimukset.fi
              </BodyLink>
            </ListItem>
            <ListItem>
              <BodyLink
                href="mailto:saavutettavuus@traficom.fi"
                color="inherit"
              >
                saavutettavuus@traficom.fi
              </BodyLink>
            </ListItem>
            <ListItem>puhelinnumero vaihde 029 534 5000</ListItem>
          </List>

          <Typography variant="h4" Element="h2" className="font-normal">
            Selosteen laatiminen
          </Typography>

          <Typography>
            Tämä saavutettavuusseloste on laadittu 28.6.2025.
            <br />
            Seloste perustuu palveluntarjoajan omaan arvioon ja päivitetään, kun
            saavutettavuusarviointi on tehty.
          </Typography>
        </TypographyRhythm>
      </div>
    </LayoutGrid>
  );
};

export default Content;
